export enum BonusType {
  Unknown = 0,
  Relax = 1,
  Focus = 2,
  Chart = 3,
  Switch = 4,
  Helmet = 5,
  Pixelated = 6,
  PhoneCalculator = 7,
  AltPrice = 8,
  Freeze = 9,
  Confusion = 10,
  Lego = 11,
  Mirror = 12,
  PriceCoins = 13,
  Mask = 14,
}

export type BonusEntity = {
  type: BonusType
  lifetime: number
  duration: number
  applied: boolean
}

function create(type: BonusType, duration: number = -1) {
  return {
    type,
    lifetime: 0,
    duration,
    applied: false,
  }
}

export function createBonusEntity(type: BonusType): BonusEntity {
  create(type, 0)

  switch (type) {
    case BonusType.Relax:
      return create(type, 0)
    case BonusType.Focus:
      return create(type, -1)
    case BonusType.Chart:
      return create(type, -1)
    case BonusType.Switch:
      return create(type, -1)
    case BonusType.Helmet:
      return create(type, -1)
    case BonusType.Pixelated:
      return create(type, 8)
    case BonusType.AltPrice:
      return create(type, -1)
    case BonusType.PhoneCalculator:
      return create(type, -1)
    case BonusType.Freeze:
      return create(type, -1)
    case BonusType.Confusion:
      return create(type, -1)
    case BonusType.Lego:
      return create(type, -1)
    case BonusType.Mirror:
      return create(type, -1)
    case BonusType.PriceCoins:
      return create(type, -1)
    case BonusType.Mask:
      return create(type, -1)
  }
}
